import React from "react";
import {useAuth0} from "@auth0/auth0-react";
import "../../../App.css";

import { makeStyles } from "@material-ui/core/styles";

//import AlertDialog from "../../../blocks/AlertDialog";
//import LoadingProgress from "../../../blocks/LoadingProgress";
import PageHeader from "../../../blocks/PageHeader.js";
import PageFooter from "../../../blocks/PageFooter";

import FuelAnnexList from "../components/FuelAnnexList";
import FuelAnnexesStyles from "../styles/FuelAnnexesStyles";

const AccessControl = require ("../../../AccessControl");

function FuelAnnexes(props) {
  const classes = makeStyles(FuelAnnexesStyles)();

  const { isAuthenticated, user } = useAuth0();
  const canEdit = AccessControl.userHasAccess(user, ["Super Admin", "Admin", "Manage Fuel Contract"]);

  return (isAuthenticated &&
    <div
      className="FuelAnnexes"
      style={{
        backgroundColor: "#eeeeee",
        color: "#1b4481",
        fontWeight: 400,
        fontFamily: "Ubuntu,sans-serif",
        minHeight: "100vh",
      }}
    >
      <PageHeader
        parentProps={props}
        activeMenuItem="fuelannexes"
        pageName="Fuel Annexes"
        loggedInUser={user}
        logout={""}
      ></PageHeader>
      <div
        style={{
          marginLeft: 40,
          marginRight: 40,
          height: 2,
          backgroundColor: "#b7c3d4",
        }}
      ></div>
      <div style={{ height: 10 }}></div>

      <div
        className={classes.rooted}
        style={{ marginLeft: 20, marginRight: 20, minHeight: `calc(100vh - ${(99+2+10+57+4)}px)` }}
      >
        <FuelAnnexList canEdit={canEdit}/>
      </div>

      <PageFooter></PageFooter>
    </div>
  );
}

export default FuelAnnexes;